import { Box, Button, Grid } from '@material-ui/core';
import { Typography } from '@room-match/shared-ui-components';
import React from 'react';
import { getMobileOperatingSystem } from 'shared/utils/common';
import { AdsImg, ButtonCont, DownloadBannerCont, DownloadCont } from './DownloadBanner.styles';
import appstore from './appstore.png';
import playstore from './playstore.png';
import useWindowDimensions from 'shared/hooks/useWindowDimenstion';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { APP_STORE_URL, PLAY_STORE_URL } from 'shared/constants/LINKS';

const DownloadBanner = () => {
  const { width } = useWindowDimensions();
  const OS = getMobileOperatingSystem();
  return (
    <DownloadBannerCont>
      <DownloadCont>
        <AdsImg src="/assets/download-image.png" />
        <div>
          <CustomTypography fontSize={25} style={{ textAlign: width < 960 ? 'center' : 'center' }}>
            Download Talent App
          </CustomTypography>
          <CustomTypography fontSize={16} style={{ textAlign: width < 960 ? 'center' : 'center' }}>
            To simplify your checkin and self tape submission process.
          </CustomTypography>
        </div>
        <ButtonCont>
          {OS === 'unknown' ? (
            <>
              <Grid item>
                <Button
                  style={{ backgroundColor: 'black', borderRadius: 10, marginBottom: 10 }}
                  onClick={() => window.open(APP_STORE_URL, '_blank', 'noopener,noreferrer')}
                >
                  <img src={playstore} style={{ width: 150, height: 50, objectFit: 'contain' }} />
                </Button>
              </Grid>
              <Grid item>
                <Button
                  style={{ backgroundColor: 'black', borderRadius: 10 }}
                  onClick={() => window.open(PLAY_STORE_URL, '_blank', 'noopener,noreferrer')}
                >
                  <img src={appstore} style={{ width: 150, height: 50, objectFit: 'cover' }} />
                </Button>
              </Grid>{' '}
            </>
          ) : OS === 'iOS' ? (
            <Grid item>
              <Button
                style={{ backgroundColor: 'black', borderRadius: 10, marginBottom: 10 }}
                onClick={() =>
                  window.open(
                    'https://apps.apple.com/ph/app/casting-app-for-talent/id1634450341',
                    '_blank',
                    'noopener,noreferrer',
                  )
                }
              >
                <img src={playstore} style={{ width: 150, height: 50, objectFit: 'contain' }} />
              </Button>
            </Grid>
          ) : (
            <Grid item>
              <Button
                style={{ backgroundColor: 'black', borderRadius: 10 }}
                onClick={() =>
                  window.open(
                    'https://play.google.com/store/apps/details?id=com.castingapp.talent',
                    '_blank',
                    'noopener,noreferrer',
                  )
                }
              >
                <img src={appstore} style={{ width: 150, height: 50, objectFit: 'cover' }} />
              </Button>
            </Grid>
          )}
        </ButtonCont>
      </DownloadCont>
    </DownloadBannerCont>
  );
};

export default DownloadBanner;
